export enum TmsType {
  Loading = 0,
  Unloading = 1,
  Both = 2,
}
